var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-popover",
    {
      attrs: {
        "popper-class": "popover-select",
        placement: "top-start",
        trigger: "click",
        "visible-arrow": false
      },
      model: {
        value: _vm.visible,
        callback: function($$v) {
          _vm.visible = $$v
        },
        expression: "visible"
      }
    },
    [
      !_vm.multiple
        ? _c(
            "el-radio-group",
            {
              attrs: { value: _vm.value, size: "mini" },
              on: { input: _vm.change }
            },
            _vm._l(_vm.options, function(opt) {
              return _c(
                "el-radio",
                { key: opt.value, attrs: { label: opt.value } },
                [_vm._v(_vm._s(opt.text))]
              )
            }),
            1
          )
        : _vm._e(),
      _c("div", { attrs: { slot: "reference" }, slot: "reference" }, [
        _vm.icon && _vm.isElIcon ? _c("i", { class: _vm.icon }) : _vm._e(),
        _vm.icon && !_vm.isElIcon
          ? _c("span", {
              staticClass: "icon",
              class: { [_vm.icon]: !!_vm.icon }
            })
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }